import { action, makeObservable, observable } from 'mobx';
import { gameResultStore } from '@pascal/pascal-core/shared/core/store';
import { RoundStatus } from '@pascal/pascal-core';
import { gameStore } from './gameStore';

class GameResultDataStore {
  gameResultData = {};

  selectedResultGameTypeId = null;

  constructor() {
    makeObservable(this, {
      gameResultData: observable,
      selectedResultGameTypeId: observable,
      setInitialGameResults: action.bound,
      updateResultsByGameType: action.bound,
      selectResultsByGameTypeId: action.bound,
    });
  }

  setInitialGameResults(gameTypeId, results) {
    this.selectedResultGameTypeId = gameTypeId;
    this.gameResultData = results;
  }

  updateFinishedRoundStatus(finishedRound) {
    const { gameTypeId, resultHash, resultSalt, resultKey, roundData, id } = finishedRound;
    const updatingResults = this.gameResultData[gameTypeId]?.map((result) => {
      if (result.roundId === id) {
        return {
          ...result,
          resultHash,
          resultKey,
          resultSalt,
          roundData,
          status: RoundStatus.Finished,
        };
      }
      return result;
    });
    this.updateResultsByGameType(gameTypeId, updatingResults);
  }

  updateResultsByGameType(gameType, results) {
    this.gameResultData[gameType] = results;
    if (gameStore.activeGameType === gameType) {
      gameResultStore.setGameResults(results);
    }
  }

  selectResultsByGameTypeId(gameTypeId) {
    this.selectedResultGameTypeId = gameTypeId;
    const selectedResult = this.gameResultData[gameTypeId];
    gameResultStore.setGameResults(selectedResult);
  }
}
export const gameResultsDataStore = new GameResultDataStore();
